import React from "react";
var __jsx = React.createElement;
import { ELSButton } from "components/common/elsevier/Button/Button";
import { ELSDivider } from "components/common/elsevier/Divider/Divider";
import { ELSLink } from "components/common/elsevier/Link/Link";
import { ELSTypography } from "components/common/elsevier/Typography/Typography";
import * as EVUrl from "components/common/utils/EVUrl";
import { ELSGrid } from "components/common/elsevier/Grid/Grid";
import RightIcon from "components/common/elsevier/Icons/RightIcon";
import { selectUsersessionData } from "redux/reducers/userSessionReducer";
import { selectSearchHistoryState } from "redux/reducers/searchHistoryReducer";
import { useSelector } from "react-redux";
import styles from "./Styles.module.scss";
import HistoryRow from "./HistoryRow";
export default function MostRecentSearches() {
  var _userSession$user;
  var userSession = useSelector(selectUsersessionData);
  var history = useSelector(selectSearchHistoryState);

  // Get the search history using old school useSWR until API is ready...
  if (history.state === "init" || history.state === "pending") return /*#__PURE__*/React.createElement(ELSTypography, {
    component: "div",
    className: "ev__search-history"
  }, "Retrieving search history...");
  if (history.state === "error") return /*#__PURE__*/React.createElement(ELSTypography, {
    component: "div",
    className: "ev__search-history"
  }, "Unable to retrieve search history.");
  if ((userSession === null || userSession === void 0 ? void 0 : (_userSession$user = userSession.user) === null || _userSession$user === void 0 ? void 0 : _userSession$user.userAnonymity) === "INDIVIDUAL" && history.count === 0) return /*#__PURE__*/React.createElement(ELSGrid, {
    container: true,
    className: "".concat(styles["recently-searched__max-width"])
  }, /*#__PURE__*/React.createElement(ELSGrid, {
    className: styles["recently-searched__no-history-title"],
    item: true,
    xs: 12,
    md: 12,
    lg: 12,
    xl: 12
  }, /*#__PURE__*/React.createElement("div", {
    "data-cy": "recent-search-history--title"
  }, "Recently searched")), /*#__PURE__*/React.createElement(ELSTypography, {
    component: "div",
    className: "".concat(styles["recently-searched__no-history-text"], " ev__search-history-no-history"),
    "data-cy": "recent-search-history--no-history-description"
  }, "Start searching and your history will appear here.", /*#__PURE__*/React.createElement("br", null), "If you need help to start searching, see our", " ", /*#__PURE__*/React.createElement(ELSLink, {
    className: "ev__search-history-tips es-link__black--16-font--text-underline",
    rel: "noopener nofollow noreferrer",
    target: "_blank",
    href: "https://service.elsevier.com/app/answers/detail/a_id/25941/supporthub/engineering-village/",
    "data-cy": "recent-search-history--no-history-search-tip-link"
  }, "search tips", /*#__PURE__*/React.createElement("span", {
    className: "sr-only"
  }, "opens in new window")), "."));
  // user is not signed in
  if (history.count === 0) return /*#__PURE__*/React.createElement(ELSGrid, {
    container: true,
    className: "".concat(styles["recently-searched__max-width"])
  }, /*#__PURE__*/React.createElement(ELSGrid, {
    className: styles["recently-searched__no-history-title"],
    item: true,
    xs: 12,
    md: 12,
    lg: 12,
    xl: 12
  }, /*#__PURE__*/React.createElement("div", {
    "data-cy": "recent-search-history--title"
  }, "Recently searched")), /*#__PURE__*/React.createElement(ELSTypography, {
    component: "div",
    className: "".concat(styles["recently-searched__no-history-text"], " ev__search-history-no-anony-history"),
    "data-cy": "recent-search-history--no-history-description"
  }, "Start searching and your history will appear here.", /*#__PURE__*/React.createElement("br", null), "If you need help to start searching, see our", " ", /*#__PURE__*/React.createElement(ELSLink, {
    className: "ev__search-history-tips es-link__black--16-font--text-underline",
    rel: "noopener nofollow noreferrer",
    target: "_blank",
    href: "https://service.elsevier.com/app/answers/detail/a_id/25941/supporthub/engineering-village/",
    "data-cy": "recent-search-history--no-history-search-tip-link"
  }, "search tips", /*#__PURE__*/React.createElement("span", {
    className: "sr-only"
  }, "opens in new window")), ".", /*#__PURE__*/React.createElement("p", {
    "data-cy": "recent-search-history--no-history-user-is-not-signin"
  }, /*#__PURE__*/React.createElement(ELSLink, {
    className: "ev__search-history-sign-in es-link__black--16-font--text-underline",
    rel: "noopener nofollow noreferrer",
    href: EVUrl.buildAuthSigninEndpoint(),
    "data-cy": "recent-search-history--no-history-sign-in-link"
  }, "Sign in"), " ", "to make sure your searches are saved, otherwise they are removed when you close the browser.")));
  return /*#__PURE__*/React.createElement(ELSGrid, {
    container: true,
    className: "".concat(styles["recently-searched__max-width"])
  }, /*#__PURE__*/React.createElement(ELSGrid, {
    className: styles["recently-searched__title"],
    item: true,
    xs: 12,
    md: 12,
    lg: 12,
    xl: 12
  }, /*#__PURE__*/React.createElement("div", {
    "data-cy": "recent-search-history--title"
  }, "Recently searched")), history.ids.slice(0, 5).map(function (item, index) {
    return /*#__PURE__*/React.createElement(HistoryRow, {
      key: history.ids[index],
      history: history.entities[item],
      item: item
    });
  }), /*#__PURE__*/React.createElement(ELSDivider, null), /*#__PURE__*/React.createElement(ELSGrid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React.createElement(ELSButton, {
    className: "".concat(styles["recently-searched__show-all-button"], " es-link__blue--16-font"),
    href: EVUrl.buildSearchHistoryUrl(),
    "data-cy": "recent-search-history--view-all",
    "data-aa-name": "view-all-history"
  }, /*#__PURE__*/React.createElement("span", null, "View all history"), /*#__PURE__*/React.createElement(RightIcon, {
    className: styles.icon__right,
    fontSize: "small"
  }))));
}